import styled, { css } from "styled-components";

export const PPCard = styled.div<{ isSelected: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px;
  outline: none;
  ${(props) =>
    props.isSelected
      ? css`
          background-color: ${({ theme }) =>
            theme.colorTokens.background.layer};
          position: relative;

          &::before {
            content: "";
            position: absolute;
            width: 2px;
            top: 0;
            left: 0;
            bottom: 0;
            background-color: ${({ theme }) =>
              theme.colorTokens.background.layer};
          }
        `
      : css`
          background-color: ${({ theme }) =>
            theme.colorTokens.background.surface};
        `};

  @media (pointer: fine) {
    &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.colorTokens.background.layer};
    }
  }

  @media (pointer: coarse) {
    &:active {
      background-color: ${({ theme }) => theme.colorTokens.background.layer};
    }
  }
`;

export const RaceInfo = styled.div`
  width: 100%;
  flex: 1 1 auto;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  max-width: 100%;
  font-family: ${({ theme }) => theme.fonts.bold};
  font-style: normal;
  font-weight: bold;
  line-height: 22px;
`;

export const Title = styled.span`
  font-family: ${({ theme }) => theme.fonts.bold};
  font-size: 16px;
  color: ${({ theme }) => theme.colorTokens.content.default};
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TitleComplement = styled.span`
  font-family: ${({ theme }) => theme.fonts.bold};
  font-size: 16px;
  color: ${({ theme }) => theme.colorTokens.content.default};
  display: inline-block;
  flex-shrink: 0;
`;

export const Date = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  margin-right: 4px;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-style: normal;
  line-height: 18px;
`;

export const IconWrapper = styled.span`
  margin-left: 4px;
`;

export const RaceDataList = styled.ul`
  margin-top: 4px;
  list-style: none;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
`;

export const RaceDataListItem = styled.li<{ isHighlighted?: boolean }>`
  font-family: ${({ isHighlighted, theme }) =>
    isHighlighted ? theme.fonts.medium : theme.fonts.regular};
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  display: flex;
  align-items: center;
  margin-right: 6px;
`;

export const RaceReport = styled.p`
  margin-top: 4px;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  text-align: left;
`;

export const PPCardHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const PPCardOptions = styled.div`
  display: flex;
  align-self: center;
`;

export const FavoriteTag = styled.span`
  margin-left: 6px;
  padding: 1px 6px;
  color: ${({ theme }) => theme.colorTokens.content.alert};
  background: ${({ theme }) => theme.colorTokens.background.alertSubtle};
  border-radius: 12px;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  vertical-align: text-top;
`;

export const Separator = styled.span`
  color: ${({ theme }) => theme.colorTokens.content.subtle};
`;
